import { createStructuredSelector } from 'reselect';

export const selectParameters = (state) => state.ssf?.parameters;
export const selectQuote = (state) => state.ssf?.quote;
export const selectValidatorFlag = (state) => state.ssf?.validatorFlag;
export const selectVariantId = (state) => state.ssf?.variantId;
export const selectQuantity = (state) => state.ssf?.quantity;
export const selectAddingToCart = (state) => state.ssf?.addingToCart;

export const selectDataForCart = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  variantId: selectVariantId,
  quantity: selectQuantity,
  addingToCart: selectAddingToCart
});

export const selectDataForApp = createStructuredSelector({
  parameters: selectParameters,
  quote: selectQuote,
  validatorFlag: selectValidatorFlag
});